export default function JSRemoteExecutionView({}: any) {
  return null;
}
